import { Tabs, Text } from '@mantine/core';
import ServiceChannelPanel from './ServiceChannelPanel';

interface IPropsServiceChannel {
  data?: any;
  companyInfo?: {
    companyId?: number;
    data?: {
      name?: string;
      email?: string;
      tel?: string;
    };
  };
}

export default function ServiceChannel(props: IPropsServiceChannel) {
  const { data, companyInfo } = props;

  return (
    <div>
      <Text fw="bold" py="md" size="md">
        서비스 채널
      </Text>
      <Tabs defaultValue="SCAUTR">
        <Tabs.List>
          {data
            .filter((item: any) => item.name !== 'RELAY_POINT')
            .map((item: any) => (
              <Tabs.Tab value={item.name} key={item.name}>
                {item.name}
              </Tabs.Tab>
            ))}
        </Tabs.List>
        {data.map((item: any) => (
          <Tabs.Panel value={item.name} key={item.name}>
            <ServiceChannelPanel companyInfo={companyInfo} serviceChannel={item.name} config={data} serviceConfig={item} />
          </Tabs.Panel>
        ))}
      </Tabs>
    </div>
  );
}
